/**
 * Creation tool's gif/video creation and uploading status.
 */
enum CreationToolStatus {
    Idle = 'CT_STATUS_IDLE',
    ConvertingToSticker = 'CT_STATUS_CONVERTING_STICKER',
    Generating = 'CT_STATUS_GENERATING',
    Uploading = 'CT_STATUS_UPLOADING',
    Downloading = 'CT_STATUS_DOWNLOADING',
    Complete = 'CT_STATUS_COMPLETE',
}

namespace CreationToolStatus {
    /**
     * Returns the status' short label text for display.
     */
    export function label(status: CreationToolStatus): string {
        switch (status) {
            case CreationToolStatus.Idle:
                return ''
            case CreationToolStatus.ConvertingToSticker:
                return 'Converting to Sticker'
            case CreationToolStatus.Generating:
                return 'Generating'
            case CreationToolStatus.Uploading:
                return 'Uploading'
            case CreationToolStatus.Downloading:
                return 'Downloading'
            case CreationToolStatus.Complete:
                return 'Completing'
        }
    }

    /**
     * Returns the status' title text for display.
     */
    export function title(status: CreationToolStatus): string {
        switch (status) {
            case CreationToolStatus.Idle:
                return ''
            case CreationToolStatus.ConvertingToSticker:
                return 'Casting Sticker Spell'
            case CreationToolStatus.Generating:
                return 'Generating your GIF'
            case CreationToolStatus.Uploading:
                return 'Uploading'
            case CreationToolStatus.Downloading:
                return 'Downloading'
            case CreationToolStatus.Complete:
                return 'Completing'
        }
    }
}

export default CreationToolStatus
